import { useTranslation } from 'react-i18next';

import * as S from '@/components/common/Tab/TabList/style';
import useIsMobile from '@/hooks/useIsMobile';

interface TabListProps {
	menuList: string[];
	menuKey: string;
	isNotSticky?: boolean;
	onListClick: (menu: string) => void;
}

const TabList = ({ menuList, menuKey, onListClick, isNotSticky = false }: TabListProps) => {
	const { t } = useTranslation();
	const isMobile = useIsMobile(1180);

	if (isMobile) {
		return null;
	}

	return (
		<S.TabListContainer isNotSticky={isNotSticky} aria-label="Section navigation">
			{menuList.map((menu, index) => (
				<S.TabListItem
					key={index}
					type="button"
					className={menuKey === menu ? 'active' : ''}
					aria-current={menuKey === menu ? 'page' : undefined}
					onClick={() => onListClick(menu)}
				>
					{t(menu)}
				</S.TabListItem>
			))}
		</S.TabListContainer>
	);
};

export default TabList;
